<!-- /src/components/common/Card/Logo.vue -->
<template>
  <div class="card">
    <router-link
      :to="{ name: routeToName, params: { sessionType: postType, slug } }"
      class="card__content"
    >
      <div
        class="card__image"
        :style="{ backgroundImage: 'url(' + cardImage + ')' }"
      >
      <div v-if="isMVP"
        class="card__mvp-banner">
        MVP
      </div>
    </div>
    </router-link>
  </div>
</template>

<script>
// import AuthorChip from '@/components/Bio/AuthorChip'
import secondConversions from '@/components/common/utils/filters/secondConversions'
import postMixin from '@/mixins/postMixin'

export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },

  mixins: [postMixin],

  // components: {
  //   AuthorChip,
  // },

  filters: {
    ...secondConversions,
  },
}
</script>

<style scoped>
.card {
  background-color: white;
  /* display: flex;
  flex-direction: column; */
  height: 100%;
  width: 100%;
  box-shadow: 0 0 1rem rgba(154, 162, 178, 0);
  transition: box-shadow 0.5s ease, transform 0.5s ease;
  border-radius: 4px;
  /* overflow: hidden; */
  will-change: box-shadow, transform;

  &:hover {
    box-shadow: 0 0.5rem 1rem rgba(154, 162, 178, 0.5);
    transform: translateY(-5px);

    .card__bottom {
      background-color: var(--brandAccent);
    }
  }

  @media (--tablet) {
    margin-bottom: 0;
  }

  &__image {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    width: 100%;
    padding-top: 100%;
    position: relative;
  }

  &__content {
    /* flex: 1; */
    /* padding: 1.5rem; */
    cursor: pointer;
    display:block;

    &__container {
      padding: 0 1rem 0.75rem 1rem;
    }
  }

  &__mvp-banner {
    position: absolute;
    top: -.3rem;
    right: -.5rem;
    background-color: var(--brandAccent);
    border-radius: 4px 4px 0 4px;
    padding: .2rem .5rem .2rem .5rem;
    color: white;
    font-size: .6rem;
    z-index: 3;
    font-weight: 800;

    &::after {
      content: "";
      background-color: #ac5412;
      width: .5rem;
      height: .5rem;
      bottom: -.5rem;
      right: 0;
      z-index: 5;
      position: absolute;
      letter-spacing: .03rem;
      clip-path: polygon(0% 0%, 100% 0%, 0% 100%)
    }
  }
}
</style>
